import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const Cancel:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
